import { createContext, useState } from "react";
import { ThemeContextType } from "../constants/types";
import { THEMES } from "../theme/theme";
import { Theme, createTheme } from "@mui/material/styles";

const lightTheme: Theme = createTheme({
  aapnoParichayTheme: THEMES.schemes.light,
});

const darkTheme: Theme = createTheme({
  aapnoParichayTheme: THEMES.schemes.dark,
});

const defaultThemeContext: ThemeContextType = {
  mode: "light",
  theme: lightTheme,
  toggleTheme: () => {},
  isDrawerOpen: false,
  toggleDrawer: () => {},
};

export const ThemeContext = createContext(defaultThemeContext);

const ThemeProvider = ({ children }: { children: any }) => {
  const [theme, setTheme] = useState<Theme>(darkTheme);
  const [mode, setMode] = useState<string>("dark"); //handle later for changing theme
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(true);

  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev);
  };

  const toggleTheme = () => {
    setTheme(() => (mode === "light" ? lightTheme : darkTheme));
  };

  return (
    <ThemeContext.Provider
      value={{ mode, theme, toggleTheme, isDrawerOpen, toggleDrawer }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
